import { useRouteBlockerStore } from "@/store/routeblocker.js";
import { useUserStore } from "@/store/user";
import { useLanguageStore } from "@/store/language";
import { useAuth, useOidcStore } from "vue3-oidc";
import { initRapsotecAuth } from "@/api/rapsotecClient";
import { initIrisAuth } from "@/api/irisClient";
import { setRapsotecTelemetryUser } from "@/utils/telemetry";

const initRapostecUser = async (token, oidcUser) => {
  const userStore = useUserStore();
  initRapsotecAuth(token);
  initIrisAuth(token);
  if (!userStore.userProfileLoaded) {
    await userStore.fetchRapsotecUser();
  }
  setRapsotecTelemetryUser(
    oidcUser,
    userStore.getCurrentUserProfile,
    import.meta.env.VITE_APP_ENABLE_TELEMETRY,
  );
  const userLanguage = userStore.getCurrentUserProfile.language;
  if (userLanguage) {
    useLanguageStore().setLanguage(userLanguage.toLowerCase());
  }
};

const useRouterBlocker = () => {
  const routeblockerStore = useRouteBlockerStore();

  const shouldBeBlocked = (from) => {
    return (
      from.meta.block !== null &&
      from.meta.block !== undefined &&
      !routeblockerStore.passThrough
    );
  };
  const notifyBlock = (to, from) => {
    const message = from.meta.block;
    from.meta.block = null;
    // Set displayMessage store variable as a component
    // to display modal is watching on it
    routeblockerStore.displayMessage = { message, route: to };
  };
  return {
    shouldBeBlocked,
    notifyBlock,
  };
};

export default () => {
  return async (to, from, next) => {
    const { shouldBeBlocked, notifyBlock } = useRouterBlocker();
    const { signinRedirect } = useAuth();
    const oidcStore = useOidcStore();

    const userManager = oidcStore.state.value?.userManager;
    let user = oidcStore.state.value.user;
    if (shouldBeBlocked(from)) {
      notifyBlock(to, from);
      return next(false);
    }

    // If user is not set, try to get it from the userManager
    if (!user && userManager) {
      user = await userManager.getUser();
      if (user) {
        oidcStore.actions.value.setUser(user);
      }
    }
    if (!user && to.name !== "oidcCallback") {
      signinRedirect({ state: { redirectPath: to.fullPath } });
      return;
    }
    if (user && userManager) {
      try {
        await initRapostecUser(oidcStore.state.value.token, user);
        return next();
      } catch (err) {
        console.error("rapsotecRouterMiddleware", err);
        return next({ name: "unrecognized-user" });
      }
    }
    next();
  };
};
